import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
// import Typography from '@material-ui/core/Typography';
// import { prettyLocalDate } from '../../../lib/time.js';

const StyledChip = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.tealish,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
}))(Chip);

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
  },
  section: {
    width: '100%',
    padding: '1rem 0',
  },
});

const ServiceBadge = ({data}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.section}>
        <StyledChip label={data.service} />
      </div>
      {/*
      <div className={classes.section}>
        <Typography aria-label="available until" variant="body2">
          Available until: <b>{prettyLocalDate(data.active_to)}</b>
        </Typography>
      </div>
      */}
    </div>
  );
};

ServiceBadge.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ServiceBadge;
